import {
  COMPETITION_ERRORS,
  COMPETITION_PRIZE_HANDLES,
  MARKET,
  SPIN_TO_WIN_WHEEL_SEGMENTS,
} from '@nandosaus/constants';
import { indexOf, size } from 'lodash';
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';
import React from 'react';

import { STATUS } from '../constants';
import { useMarket } from '../../../hooks/use-market';
import { SpinToWinWheelAU } from './spin-to-win-wheel-au';
import { SpinToWinWheelNZ } from './spin-to-win-wheel-nz';

const {
  NAUGHTY_NATA,
  DRINK,
  LARGE_SIDE,
  SIDE,
  GRAND_PRIZE,
  GIFT_CARD,
  CHIP_DIP_VARIETIES,
  CHEESY_GARLIC_MINI_PITA,
  CHOCOLATE_MOUSSE,
} = COMPETITION_PRIZE_HANDLES;

const Wheel = ({ controls }) => {
  const market = useMarket();
  const isAusMarket = market === MARKET.AUSTRALIA;

  const getRotateValue = ({ segment }) => {
    const segments = SPIN_TO_WIN_WHEEL_SEGMENTS[market];
    const SEGMENT_ROTATE_INCREMENT = 180 / size(segments);
    const segmentIndex = indexOf(segments, segment);

    return 360 * 3 + SEGMENT_ROTATE_INCREMENT * segmentIndex;
  };

  return (
    <motion.svg width="544" height="544" viewBox="0 0 544 544" fill="none" xmlns="http://www.w3.org/2000/svg">
      <motion.g
        initial="initial"
        animate={controls}
        style={{ originX: '50%', originY: '50%' }}
        variants={{
          [STATUS.INITIAL]: {
            rotate: 0,
          },
          [STATUS.START]: {
            rotate: [0, 360],
            transition: {
              duration: 3,
              ease: 'backIn',
            },
          },
          [STATUS.SPIN]: {
            rotate: [0, 360],
            transition: {
              repeat: Infinity,
              duration: 0.9,
              type: 'tween',
              ease: 'linear',
              bounce: 1,
            },
          },
          [[GRAND_PRIZE]]: {
            rotate: getRotateValue({ segment: GRAND_PRIZE }),
            transition: {
              duration: 4,
              ease: 'easeOut',
            },
          },
          [[GIFT_CARD]]: {
            rotate: getRotateValue({ segment: GIFT_CARD }),
            transition: {
              duration: 4,
              ease: 'easeOut',
            },
          },
          [[SIDE]]: {
            rotate: getRotateValue({ segment: SIDE }),
            transition: {
              duration: 4,
              ease: 'easeOut',
            },
          },
          [[DRINK]]: {
            rotate: getRotateValue({ segment: DRINK }),
            transition: {
              duration: 4,
              ease: 'easeOut',
            },
          },
          [[NAUGHTY_NATA]]: {
            rotate: getRotateValue({ segment: NAUGHTY_NATA }),
            transition: {
              duration: 4,
              ease: 'easeOut',
            },
          },
          [[LARGE_SIDE]]: {
            rotate: getRotateValue({ segment: LARGE_SIDE }),
            transition: {
              duration: 4,
              ease: 'easeOut',
            },
          },
          [[CHOCOLATE_MOUSSE]]: {
            rotate: getRotateValue({ segment: CHOCOLATE_MOUSSE }),
            transition: {
              duration: 4,
              ease: 'easeOut',
            },
          },
          [[CHEESY_GARLIC_MINI_PITA]]: {
            rotate: getRotateValue({ segment: CHEESY_GARLIC_MINI_PITA }),
            transition: {
              duration: 4,
              ease: 'easeOut',
            },
          },
          [[CHIP_DIP_VARIETIES]]: {
            rotate: getRotateValue({ segment: CHIP_DIP_VARIETIES }),
            transition: {
              duration: 4,
              ease: 'easeOut',
            },
          },
          [STATUS.LOSE]: {
            rotate: getRotateValue({
              segment: COMPETITION_ERRORS.NO_PRIZE_WON,
            }),
            transition: {
              duration: 4,
              ease: 'easeOut',
            },
          },
        }}
      >
        {isAusMarket ? <SpinToWinWheelAU /> : <SpinToWinWheelNZ />}
      </motion.g>
    </motion.svg>
  );
};

Wheel.propTypes = {
  controls: PropTypes.shape({}).isRequired,
};

export { Wheel };
